import styled, { keyframes } from "styled-components";

const questionEnter = keyframes`
    0% {
        opacity: 0;
        transform: translateY(10px);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const Container = styled.div`
    width: 100%;
    padding: 0px 16px;
    @media (min-width: 768px) {
        width: 60%;
        margin-left: auto;
        margin-right: auto;
        max-width: 1024px;
    }
`;

export const Helptext = styled.p`
    font-size: 14px;
    font-weight: 500;
    color: rgb(255 255 255 / 70%);
    margin-top: 8px;
    margin-bottom: 0px;
`;

export const Header = styled.div`
    background-color: var(--color-petrol);
    padding: 24px 0px 16px 0px;
    background-image: url("/assets/images/behaviourAnalysisBg.png");
    background-size: cover;
    background-position: right;
    @media (min-width: 1024px) {
        background-position: center;
    }
`; 

export const Content = styled.div`
    background-color: #FBF1EA;
    padding: 32px 0px;
`;

export const Back = styled.button`
    color: var(--color-orange);
    text-decoration: underline;
    font-weight: 600;
`;

export const NavigationContainer = styled.div`
    display: flex;
    justify-content: flex-end;

    button:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: auto;
    }
`;

export const ProgressContainer = styled.div`
    margin-bottom: 16px;
    display: flex;
    align-items: center;
`;

export const Counter = styled.p`
    font-size: 12px;
    color: var(--color-blue-300);
    margin-bottom: 0px;
    margin-left: 12px;
    font-weight: 600;
`;

export const BasketProgressbar = styled.div`
  width: 100%;
  background-color: var(--color-blue-100);
  border-radius: 9px;
  height: 12px;
`;

export const BasketProgressFill = styled.div<{ width: number}>`
  height: 12px;
  width: ${({width}) =>  `${width}%`};
  border-radius: 9px;
  background-color: var(--color-orange);
`;

export const QuestionTransition = styled.div`
    animation: ${questionEnter} 0.28s ease-out;
`;